import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

export type TParams = {
  pageNumber: number;
  size: number;
  searchBy?: number;
  startDate?: string;
  endDate?: string;
  searchValue?: string;
  FunderId?: number;
  aggregatorId?: string;
  email?: string;
};

const getFunderDetails = async ({
  pageNumber,
  size,
  searchBy,
  startDate,
  endDate,
  searchValue,
  FunderId,
  aggregatorId,
  email,
}: TParams) => {
  let queryParams = `?Page=${pageNumber}&PageSize=${size}`;
  if (searchBy) {
    queryParams = `${queryParams}&FunderType=${searchBy}`;
  }
  if (startDate) {
    queryParams = `${queryParams}&from_date=${startDate}`;
  }
  if (endDate) {
    queryParams = `${queryParams}&to_date=${endDate}`;
  }
  if (searchValue) {
    queryParams = `${queryParams}&FunderName=${searchValue}`;
  }
  if (FunderId) {
    queryParams = `${queryParams}&FunderId=${FunderId}`;
  }
  if (aggregatorId) {
    queryParams = `${queryParams}&AggregatorId=${aggregatorId}`;
  }
  if (email) {
    queryParams = `${queryParams}&Email=${email}`;
  }
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.ALL_FUNDER}${queryParams}`,
  );

  return data;
};

export default function useFunderDetails({
  pageNumber,
  size,
  searchBy,
  startDate,
  endDate,
  searchValue,
  FunderId,
  aggregatorId,
  email,
}: TParams) {
  return useQuery(
    [
      {
        pageNumber,
        size,
        searchBy,
        startDate,
        endDate,
        searchValue,
        FunderId,
        aggregatorId,
        email,
      },
      "getFunderDetails",
    ],
    getFunderDetails,
  );
}
